﻿import { filtertag } from '../../v1_3/web_engine/filtertag';

export class local_filter {
    public name: string | null = null;
    isOpen: boolean = false;
    selectedTag: filtertag = new filtertag();
    public tags: filtertag[] = [];
}